import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Error404 = () => {
  const { t } = useTranslation();
   return (
      <div className="authincation h-100">
         <div className="container vh-100">
            <div className="row justify-content-center h-100 align-items-center ">
               <div className="col-md-7">
                  <div className="form-input-content text-center error-page">
                     <h1 className="error-text font-weight-bold">404</h1>
                     <h4>
                        <i className="fa fa-exclamation-triangle text-warning" />{t("pages.errors.e404.thePageYouWereLookingFor")}
                     </h4>
                     <p>
                        {t("pages.errors.e404.youMayHaveMistypedTheAddress")}
                     </p>
                     <div>
                        <Link className="btn btn-primary" to="/dashboard">
                           {t("common.ui.backToHome")}
                        </Link>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default Error404;
